import React from 'react';
import Header from "../Parts/Header.jsx";
import Footer from "../Parts/Footer.jsx";
import Sidebar from '../Parts/Sidebar.jsx';

export default function Layout(props) {
  const { children } = props;
  //Parte de la sesion del usuario
  const Usuario = JSON.parse(window.localStorage.getItem('usuario'));
  //console.log("userLayot", Usuario);
  if (Usuario == null) {
    window.location = `${process.env.BASEURL}/`;
  }

  //console.log("user", Usuario);
  return (
    <>
      {Usuario != null ?
        <>
          <div id="wrapper">
            <Sidebar Usuario={Usuario.user} />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content" className="background">
                <Header Usuario={Usuario.user} />
                {children}
              </div>
              <Footer />
            </div>
          </div>
          <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
          </a>
        </>
        : <div class="overlay" id='backdrop'>
          <div class="d-flex justify-content-center">
            <div class="spinner-grow text-primary" role="status" >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>}
    </>
  )
}
